import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, Form, ListGroup } from 'react-bootstrap';
import { getWhatsappSupportRouting, updateWhatsappSupportRouting } from '../../actions/whatsappAccess';
import { LoadingState, ErrorBanner } from './StateViews';

const SupportRoutingPanel = ({ getWhatsappSupportRouting, updateWhatsappSupportRouting }) => {
    const [data, setData] = useState(null);
    const [saving, setSaving] = useState(null);
    const [loadFailed, setLoadFailed] = useState(false);

    const load = useCallback(async () => {
        setLoadFailed(false);
        const result = await getWhatsappSupportRouting();
        if (!result) return setLoadFailed(true);
        setData(result);
    }, [getWhatsappSupportRouting]);

    useEffect(() => {
        load();
    }, [load]);

    const choose = async (type, key) => {
        setSaving(type);
        const result = await updateWhatsappSupportRouting({ [type]: key });
        setSaving(null);
        if (!result) return;
        setData((current) => ({ ...current, routing: result.routing }));
    };

    return (
        <Card className="shadow-sm h-100">
            <Card.Header className="fw-semibold">Where each request goes</Card.Header>
            <Card.Body>
                <div className="text-muted small">
                    Pick the alert group for each kind of customer request. People ticked for Support requests or Sales requests above receive the matching ones.
                </div>
                {loadFailed && <ErrorBanner message="Failed to load the request routing" onRetry={load} />}
                {!loadFailed && !data && <LoadingState />}
            </Card.Body>
            {data && (
                <ListGroup variant="flush">
                    {Object.entries(data.requestTypes).map(([type, label]) => (
                        <ListGroup.Item key={type} className="d-flex justify-content-between align-items-center">
                            <span>{label}</span>
                            <Form.Select
                                size="sm"
                                style={{ width: 'auto' }}
                                aria-label={`Alert group for ${label}`}
                                value={data.routing[type]}
                                disabled={saving === type}
                                onChange={(event) => choose(type, event.target.value)}
                            >
                                {Object.entries(data.alertOptions).map(([key, optionLabel]) => (
                                    <option key={key} value={key}>{optionLabel}</option>
                                ))}
                            </Form.Select>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            )}
        </Card>
    );
};

SupportRoutingPanel.propTypes = {
    getWhatsappSupportRouting: PropTypes.func.isRequired,
    updateWhatsappSupportRouting: PropTypes.func.isRequired
};

export default connect(null, { getWhatsappSupportRouting, updateWhatsappSupportRouting })(SupportRoutingPanel);
